<template>
  <div>
    <el-form ref="formSearch" :inline="true" :model="formDataList" label-width="80px">
      <el-form-item label="任务名称:">
        <el-input size="small" v-model="formDataList.taskName" placeholder="请输入任务名称" style="margin-right:40px;width: 200px;"></el-input>
      </el-form-item>
      <el-form-item label="人群名称:">
        <el-input size="small" v-model="formDataList.crowName" placeholder="请输入人群名称"
          style="margin-right:40px;width: 200px;"></el-input>
      </el-form-item>
      <el-form-item label="创建时间:">
        <div class="my_select_time">
          <el-date-picker prefix-icon="no_icon" v-model="formDataList.startTime" type="datetime" :placeholder="'选择日期时间'"
            size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 120px;font-size:12px" class="time1" :clearable="false"></el-date-picker>
          <div class="time_to_text">至</div>
          <el-date-picker prefix-icon="no_icon" v-model="formDataList.endTime" type="datetime" :placeholder="'选择日期时间'"
            size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 145px;font-size:12px" class="time2" :clearable="false"></el-date-picker>
          <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()" style="margin-right:0px"></i>
          <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
        </div>
      </el-form-item>
      <el-form-item label="运算进程:">
        <el-select v-model="formDataList.status" style="width: 200px;">
          <el-option v-for="(item, index) in pros" :key="index" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </el-form-item>
      <el-button size="small" :disabled="tableLoding" class="search" plain @click="submitForm('formSearch')"
        style="margin:0 6px  0px 20px;font-size:14px" autofocus>
        <i class="el-icon-search" style="display:inline-block;width:14px;height:12px;font-size:14px"></i> 查询
      </el-button>
      <el-button size="small" class="reset" @click="resetForm" plain style="margin: 0 auto;">重置</el-button>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "input_form",
  props: {
    orderStatusType: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formDataList: {
        taskName: "", // 任务名称
        crowName: "", // 人群名称
        startTime: "", // 开始时间
        endTime: "", // 结束时间
        status: ""
      },
      pros: [
        { label: "全部", value: "" },
        { label: "计算中", value: "0" },
        { label: "已完成", value: "1" },
        { label: "已失败", value: "2" },
      ], // 任务进程
      tableLoding: false,
    };
  },
  mounted() {
    this.$emit("onSerach", this.formDataList);
  },
  methods: {
    clearTimeSendTime() {
      this.formDataList.startTime = "";
      this.formDataList.endTime = "";
    },
    submitForm() {
      this.$emit("onSerach", this.formDataList);
    },
    resetForm() {
      this.formDataList = {
        taskName: "",
        crowName: "",
        startTime: "",
        endTime: "",
        status: ""
      };
      this.$emit("onSerach", this.formDataList);
    },
  },
};
</script>

<style lang="scss" scoped>
// /deep/.my_select_time .el-input__inner {
//   padding: 0px 8px !important;
// }
.el-input,
.el-select {
  width: 280px;
}

.range-num {
  .el-input {
    width: 125px;
  }

  .to {
    padding: 0 8px;
  }
}

.select-input-type {
  .el-select {
    width: 136px;
    margin-right: 8px;
  }

  .el-input {
    width: 136px;
  }
}

.btn_group {
  text-align: center;
}

.search,
.reset {
  width: 98px !important;
  font-size: 14px;
  height: 32px !important;
  transition: all 0.2s;
}

.search {
  color: #fe4d45;
  border: 1px solid #fe4d45;
  background-color: #fff;

  &:hover {
    color: #fff;
    border: 1px solid #fff;
    background-color: #fe4d45;
  }
}

.reset {
  color: #666666;
  border: 1px solid #dddddd;
  background-color: #fff;

  &:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}</style>